// extracted by mini-css-extract-plugin
export default {"app_policy":"Terms_app_policy__T+dNm"};